angular.module('core')
    .constant("ERROR_CODES", {

        //REM: Error codes 100-999 reserved for HTTP status codes

        UNKNOWN_ERROR: "9000",

        //
        // 1000 series: Issues related to account data in Magneto, or being out of sync between Product and Magneto
        //

        //Object (student, classroom, etc.) in G2 that doesn't have Magneto provisioning id, can't be edited.
        EDIT_MODE_BLOCKED: "1000",

        //
        // 2000 series: Issues related to account data in G2, or being out of sync between Product and G2
        //

        //School Admin presumably with classrooms in Product, but none in G2
        ADMIN_NO_CLASSROOMS_IN_G2: "2000",


        //
        //don't go changin' ...
        //

        /**
         * Attempts to find the property name of a defined error code in this constants object.
         * @param code String
         * @returns {*} If found, returns the label (String); else, null.
         */
        lookupLabel: function(code) {
            for (var k in this) {
                if (this.hasOwnProperty(k) && typeof this[k] === "string" && this[k] === code) {
                    return k;
                }
            }
            return null;
        },

        /**
         * See lookupLabel() method.  This returns a pretty-fied version of the return from that method,
         * by converting "_" to spaces, and converting the resulting string to Title Case.
         */
        lookupPrettyLabel: function(code) {
            var label = this.lookupLabel(code);
            if (label) {
                return label.replace(/_/g," ").replace(/\w\S*/g, function(m) { return m.charAt(0).toUpperCase() + m.substr(1).toLowerCase(); });
            }
            return null;
        }

    });